<template>
    <div class="group-select">
        <label v-for="group of groups" :key="group.id" :class="getClassName(group.id)">
            <span class="group-select__name">{{ group.name}}</span>
            <input v-if="group.status.handle == 'active'"
                class="group-select__input" 
                type="radio" 
                name="selectedItemGroup[]" 
                :id="group.id" 
                :value="group.id" 
                @change="$emit('update-selected-group', $event.target.value)">
            <div class="group-select__notice">{{ group.notice }}</div>
        </label>
    </div>
</template>
<script>
    export default {
        props: {
            'activeGroup' : {
                type: Number
            },
            'groups' : {
                type : Object

            },
            'className' : {
                type : String
            }
        },
        emits: ['update-selected-group'],
        methods: {
            getClassName(id) {
                const baseClass = 'group-select__label';
                let className = `${baseClass} ${baseClass}--${this.className}`;
                if (this.activeGroup == id) {
                    className += ` ${baseClass}--active`;
                }
                if (this.groups.find(group => group.id == id).status.handle == 'teaser') {
                    className += ` ${baseClass}--disabled`;
                }

                return className;
            },
        }
    }
</script>